import React from 'react';

const MessageCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.014c0 1.114.317 2.194.905 3.114.515.758 1.478 1.517 3.147 2.093s3.475.673 4.875-.45a1.875 1.875 0 001.5-3.014 1.875 1.875 0 00-1.5-3.014c-1.4-1.123-3.3-1.006-4.875-.45s-2.632 1.335-3.147 2.093A8.625 8.625 0 012.25 12c0 1.114.317 2.194.905 3.114z"
        />
    </svg>
);

export default MessageCircleIcon;
